import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import { PRODUCT_SALE_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import ExpertPaymentInfoBox from "@src/components/expert/ticket/ExpertPaymentInfoBox";

import ico_match_price_ticket from "@src/assets/expert/ticket/ico_match_price_ticket.png";
import PackageCard from "@src/components/deungi/DeungiPackageCard";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";
import { useTicketPackageList } from "@src/hooks/deungi/useTicketPackageList";
import { checkDevice } from "@src/components/deungi/common/utils";
import { transferToNative } from "@src/lib/WebAppBridge";

interface ExpertMatchPricePackageListBoxProps {
    originalPrice: number;
}

const ExpertMatchPricePackageListBox = ({ originalPrice }: ExpertMatchPricePackageListBoxProps) => {
    const deviceType = checkDevice();
    const ticketImage = ico_match_price_ticket;
    const ticketTypeString = TICKET_TYPE_STRING.MATCH_PRICE_TICKET;
    const ticketTitle = "전문가 매칭 가격 재설정";

    const [packageList, setPackageList] = useState({} as TicketPackageListResponseDto[]);

    const getPackageList = async () => {
        const saleType = deviceType === "ios" ? PRODUCT_SALE_TYPE.IOS : PRODUCT_SALE_TYPE.AOS;
        const res = await useTicketPackageList(saleType);
        if (res.data) {
            setPackageList(res.data.list);
        }
    };

    useEffect(() => {
        getPackageList();
    }, []);

    const onPackageClickHandler = (data: TicketPackageListResponseDto) => {
        if (!data) return;
        if (data?.type === ticketTypeString) {
            if (deviceType !== "android") {
                const ticketType = ["", ...Object.values(TICKET_TYPE_STRING)];
                const params = JSON.stringify({
                    productCode: data.code,
                    productType: data.type,
                    ticketType: ticketType.indexOf(data.type),
                });
                transferToNative(params, "payTicketInApp");
            } else {
                const params = JSON.stringify({
                    pgType: "kcp.IP29N",
                    product_name: data.name,
                    product_code: data.code,
                    discounted_price: data.discountPrice,
                    type: ticketTypeString,
                    searchText: "",
                });
                transferToNative(params, "payDeungiTicket");
            }
        }
    };

    return (
        <Container>
            <PackageCard
                title={ticketTitle}
                packages={
                    packageList && packageList.length > 0
                        ? packageList.filter((el) => el.type === ticketTypeString && el.originalPrice == originalPrice)
                        : []
                }
                singleTicketImage={ticketImage}
                active={true}
                onTitleClick={() => {}}
                onPackageClick={onPackageClickHandler}
                onScroll={() => {}}
            />

            <ExpertPaymentInfoBox ticketType={ticketTypeString} title={ticketTitle} />
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
    overflow: scroll;
    background-color: white;
    .backDiv {
        width: 0;
        height: 75px;
    }
`;

export default ExpertMatchPricePackageListBox;
